import React from 'react';
import styles from './StatusPill.module.css';

/** Selo de situação. tone: success | warning | error | info | neutral */
const StatusPill = ({ tone = 'neutral', children }) => (
  <span className={`${styles.pill} ${styles[tone] || styles.neutral}`}>{children}</span>
);

export default StatusPill;
